import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import classes from './Novedad.module.css';


export class NovedadesConteiner     extends Component {
    render() {
        return (
                <div className='card'>
                    <div className='card-body'>
                        <h4 className='card-title'>Titulo Novedad...</h4>
                        <a>19/09/2022</a>
                        <p className='card-text text-secondary'>lorem asdasd asd asd asd asdasd aasdasda as as dasda sd...</p>
                    </div>
                   <a style={{}} href='#!' className={classes.botonNovedad}>Leer Más</a>
                </div>
        )
    }
}

export default NovedadesConteiner
